import { render, staticRenderFns } from "./AppDescriptionChileJuegosOlimpicosTimeline.vue?vue&type=template&id=7b9d2059&"
import script from "./AppDescriptionChileJuegosOlimpicosTimeline.vue?vue&type=script&lang=js&"
export * from "./AppDescriptionChileJuegosOlimpicosTimeline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports